import React, { useState } from "react";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";

export default function LoginForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess(false);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      setSuccess(true);
      setTimeout(() => {
        navigate("/account");
      }, 1200); // Show success for 1.2s then redirect to account page
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="form login-form" onSubmit={handleLogin} style={{ maxWidth: 340, margin: "32px 0 0 0", textAlign: "left" }}>
      <h2 style={{ marginBottom: 18 }}>Login</h2>
      <label>Email
        <input type="email" value={email} onChange={e => setEmail(e.target.value)} required />
      </label>
      <label>Password
        <input type="password" value={password} onChange={e => setPassword(e.target.value)} required autoComplete="current-password" />
      </label>
      <button className="btn btn-primary" type="submit" disabled={loading}>
        {loading ? "Logging in..." : "Login"}
      </button>
      {error && <div style={{ color: "#e53e3e", marginTop: 12 }}>{error}</div>}
      {success && <div style={{ color: "#3182ce", marginTop: 12 }}>Login successful! Redirecting...</div>}
    </form>
  );
}
